import * as apisPortal from '/@src/client-portal/api'

//api ciselniky obce staty
const getCiselniky = new apisPortal.CiselnikApi()
const getEnumeracie = new apisPortal.EnumeraciaApi()

// TODO temporarily turned off, dont delete please
export const prepare = (data, label) => {
  return data /*? [
    { id: '', kodZdroj: null, nazov: label },
    ...data
  ] : []*/
}

interface CiselnikOptionsType {
  name: string
  platny?: boolean
  rsql?: string
  page?: number
  size?: number
  sortBy?: string
  direction?: string
  parseResponse?: Function
}

interface CiselnikPlnyType {
  name: string
  platny?: boolean
  rsql?: string
  page?: number
  size?: number
  sortBy?: string
  direction?: string
}

export const getCiselnikData = ({
  name,
  platny = true,
  rsql = undefined,
  page = undefined,
  size = 500,
  sortBy = 'nazov',
  direction = 'ASC',
  parseResponse = undefined,
}: CiselnikOptionsType) => {
  return getCiselniky
    .findZakladnyCiselnikByNameCiselnik(name, platny, rsql, page, size, sortBy, direction)
    .then((response) => {
      const content = response.data.content
      return parseResponse ? parseResponse(content) : content
    })
}

export const getPlnyCislenikData = ({
  name,
  platny = true,
  rsql = undefined,
  page = undefined,
  size = 500,
  sortBy = 'nazov',
  direction = 'ASC',
}: CiselnikPlnyType) => {
  return getCiselniky
    .findPlnyCiselnikByNameCiselnik(name, platny, rsql, page, size, sortBy, direction)
    .then((response) => {
      const content = response.data.content
      return content
    })
}

export const getHierarchiaNuts = (id) => {
  return getCiselniky.getHierarchiaNutsCiselnikaByIdCiselnik(id).then((r) => {
    return r.data
  })
}

export const getKrajOkresByObecId = (id) => {
  return getHierarchiaNuts(id).then((r) => {
    return {
      kraj: r.hierarchy[3],
      okres: r.hierarchy[4],
    }
  })
}

export const getCiselnik = (name) => {
  return getCiselnikData({ name })
}

export const getCiselnikWithDefault = (name, label = 'Vyberte jednu možnosť') => {
  return getCiselnik(name).then((data) => {
    return prepare(data, label)
  })
}

//find stat
export function getStates() {
  return getCiselnik('stat')
}
export const getStat = getStates

export function getKraj(statId: string) {
  return getCiselnikData({ name: 'nuts', rsql: `stat.id==${statId} and uroven==3` })
}

export function getOkres(krajId: string) {
  return getCiselnikData({ name: 'nuts', rsql: `nadradene.id==${krajId} and uroven==4` })
}

export function getObec(okresId: string) {
  return getCiselnikData({ name: 'nuts', rsql: `nadradene.id==${okresId} and uroven==5` })
}

const addCustomValue = (value: any, arrayOfValues: any) => {
  const customValue = {
    id: value,
    nazov: value,
  }

  const isValuePresent = arrayOfValues.some((valueCurrent: any) => {
    return customValue.id === valueCurrent.id
  })

  if (!isValuePresent) {
    arrayOfValues.push(customValue)
  }
}

export async function getUlica(
  obecId: number | undefined,
  ulicaNazov?: string,
  customUlica?: any
) {
  const zoznamUlic: { id: string; nazov: string }[] = []
  await getPlnyCislenikData({
    name: 'ulicapsc',
    rsql: `${obecId ? `obec.id==${obecId} and ` : ''} ulica=ilike="*${
      ulicaNazov ? ulicaNazov : ''
    }*"`,
  }).then((response) => {
    const streetSet: Set<any> = new Set()

    response?.forEach((element) => {
      streetSet.add(
        JSON.stringify({
          id: element.additionalProperties?.ulica,
          nazov: element.additionalProperties?.ulica,
        })
      )
    })

    const list = Array.from(streetSet)
    list.forEach((element: any) => {
      const el = JSON.parse(element)
      zoznamUlic.push(el)
    })
  })

  if (customUlica) {
    addCustomValue(customUlica, zoznamUlic)
  }

  return zoznamUlic
}

export async function getPSC(
  obecId: number | undefined,
  pscNazov?: string,
  customPsc?: any,
  ulicaId?: number | undefined | string
) {
  const zoznamPSC: { id: string; nazov: string }[] = []
  const pscsSet: Set<any> = new Set()
  const streetsAll = await getUlica(obecId)

  await getPlnyCislenikData({
    name: 'ulicapsc',
    rsql: `${obecId ? `obec.id==${obecId} and ` : ''} psc=ilike="*${
      pscNazov ? pscNazov : ''
    }*" ${
      ulicaId && streetsAll.some((ulica) => ulica.nazov === ulicaId)
        ? `and ulica=="${ulicaId}"`
        : ``
    }`,
  }).then((response) => {
    let pscToCheck = ''
    response?.forEach((item) => {
      if (pscToCheck !== item.additionalProperties?.psc) {
        pscsSet.add(
          JSON.stringify({
            id: item.additionalProperties?.psc,
            nazov: item.additionalProperties?.psc,
            obec: item.additionalProperties?.obecNazov,
            okres: item.additionalProperties?.okres,
          })
        )
        pscToCheck = item.additionalProperties?.psc
      }
    })
  })

  const list = Array.from(pscsSet)
  list.forEach((element) => {
    const el = JSON.parse(element)
    zoznamPSC.push(el)
  })

  if (customPsc) {
    addCustomValue(customPsc, zoznamPSC)
  }

  return zoznamPSC
}

export function getObecByStat(statId: string) {
  // size value should be really big because you are not filtering with hierarchy
  return getCiselnikData({
    name: 'nuts',
    rsql: `stat.id==${statId} and uroven==5`,
    size: 99999,
  })
}

//find stat
export function getStatesRaw() {
  return getCiselnik('stat')
}

export function getKrajRaw(statId: string) {
  return getKraj(statId)
}

export function getOkresRaw(krajId: string) {
  return getOkres(krajId)
}

export function getObecRaw(okresId: string) {
  return getObec(okresId)
}

export function getPravnaForma() {
  return getCiselnik('pravnaForma')
}

export function getUctovnictvo() {
  return getCiselnik('uctovnictvo')
}

export function getDruhVlastnictva() {
  return getCiselnik('druhVlastnictva')
}

export function getZaradenieTyp() {
  return getEnumeracie
    .findEnumerationByNameEnumeracia(
      'vztah_osoby_k_organizacii',
      undefined,
      undefined,
      500,
      'nazov',
      'ASC'
    )
    .then((response) => {
      return response.data.content
    })
}

export function getTitlesBeforeName() {
  return getCiselnik('titulpredmenom')
}

export function getTitlesAfterName() {
  return getCiselnik('titulzamenom')
}
